import React, { useEffect, useMemo, useState } from "react";
import { getThumbnailSources, THUMBNAIL_SIZES } from "../lib/freeArea";

// 16:9 box is reserved up front (no layout shift); a failed or missing image falls through
// the candidate list and finally to a branded placeholder instead of a broken-image icon.
export default function VideoThumbnail({ video, alt = "", children }) {
  const sources = useMemo(() => getThumbnailSources(video), [video]);
  const signature = sources.map((s) => s.src).join("|");
  const [failedCount, setFailedCount] = useState(0);

  useEffect(() => setFailedCount(0), [signature]);

  const current = sources[failedCount];

  return (
    <div
      className="relative aspect-video w-full overflow-hidden rounded-t-xl bg-zinc-950"
      data-testid="video-thumbnail"
      data-fallback={current ? undefined : "true"}
    >
      {current ? (
        <img
          key={current.src}
          src={current.src}
          srcSet={current.srcSet}
          sizes={current.srcSet ? THUMBNAIL_SIZES : undefined}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={() => setFailedCount((n) => n + 1)}
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <div
          className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-purple-900/50 via-zinc-900 to-pink-900/40"
          role="img"
          aria-label={alt || "Video thumbnail unavailable"}
          data-testid="video-thumbnail-placeholder"
        >
          <span className="text-3xl font-bold tracking-tight text-white/70">GP</span>
        </div>
      )}
      {children}
    </div>
  );
}
